import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoadingCard from '../LoadingCard';
import { getDocument } from '../../actions/document';
import { getTypes } from '../../actions/types';
import { setNavigatedOnClient } from '../../actions/location';
import * as adobe from '../../utils/adobe';
import NoDocumentFound from './NoDocumentFound';
import DocumentError from './DocumentError';
import Document from './Document';

class DocumentContainer extends Component {
  componentWillMount() {
    const {
      match: { params },
      types,
      documentIndex,
    } = this.props;

    const identifier = decodeURIComponent(params.identifier);

    if (!documentIndex[identifier]) {
      this.props.getDocument(identifier);
    }

    if (!types) {
      this.props.getTypes();
    }
  }

  componentDidMount() {
    if (this.props.navigatedOnClient) {
      adobe.trackArticlePageView();
    } else {
      this.props.setNavigatedOnClient();
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      match: {
        params: { identifier }
      },
      documentIndex,
    } = nextProps;

    if (!documentIndex[identifier]) {
      this.props.getDocument(identifier);
    }
  }

  render() {
    const {
      match: { params },
      documents,
      documentIndex,
    } = this.props;

    const identifier = decodeURIComponent(params.identifier);
    const documentInfo = documentIndex[identifier];

    if (!documentInfo) {
      return (
        <LoadingCard text={`Loading: ${identifier}`} />
      );
    }

    const {
      error,
      id,
    } = documentInfo;

    if (error === 404) {
      return (
        <NoDocumentFound />
      );
    }

    if (!id || error) {
      return (
        <DocumentError identifier={identifier} />
      );
    }

    return (
      <Document
        identifier={identifier}
        doc={documents[id]}
      />
    );
  }
}

const mapStateToProps = ({
  types,
  documents,
  documentIndex,
  location,
}) => ({
  types,
  documents,
  documentIndex,
  navigatedOnClient: location.navigatedOnClient,
});

const mapDispatchToProps = {
  getDocument,
  getTypes,
  setNavigatedOnClient,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentContainer);



// WEBPACK FOOTER //
// ./src/universal/ui/components/Document/DocumentContainer.js